import React from 'react'
import ProTeacherProductList from '../proteacher/components/ProTeacherProductList'

const SchoolSkillBox = () => {
  return (
    <>
  
    <ProTeacherProductList />
  </>
  )
}

export default SchoolSkillBox
